import React, { useEffect, useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { deleteOlgu } from "Stores/actions";
import { SAVE_ALL_OLGU_DATA } from "Stores/actionTypes";
import * as Icons from 'react-bootstrap-icons';

function DeleteOlgu({ row }) {
  const { dataRelation, allOlguData, allOlguDataPagination } = useSelector(
    (state) => ({
      dataRelation: state.customer.dataRelation,
      allOlguData: state.pattern.allOlguData,
      allOlguDataPagination: state.pattern.allOlguDataPagination,
    })
  );
  const [showAlert, setShowAlert] = useState(false);
  const [deleteRelationData, setDeleteRelationData] = useState(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onShowAlert = () => {
    setShowAlert(!showAlert);
    setDeleteRelationData(null);
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdTemplate: row.Id,
        Type: row.Type,
      };
      const res = await dispatch(deleteOlgu(data, row.Name));
      if (res) {
        onShowAlert();
        dispatch({
          type: SAVE_ALL_OLGU_DATA,
          allOlguData: allOlguData.filter((item) => item.Id !== row.Id),
          allOlguDataPagination: allOlguDataPagination,
        });
      }
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  useEffect(() => {
    setDeleteRelationData(dataRelation);
  }, [dataRelation]);

  return (
    <>
      <ActionFormatter
        title={<Translator id="hazf" />}
        icon={<Icons.Trash3 size={17} />}
        className="danger-fill"
        onClick={onShowAlert}
        disabled={
            (row.IsG &&
              read("StypeU") !== "1") ||
              read("templateRules")?.accessDelete === false
        }
      />
      <AlertDialog
        showAlert={showAlert}
        type="alertError"
        onClose={onShowAlert}
        onClickOk={onDelete}
        okTitle={<Translator id="ble_pak_shavad" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
        relationText={<Translator id='relationAlert' />}
        relationData={deleteRelationData}
        loading={loading}
      />
    </>
  );
}

export default DeleteOlgu;
